import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `CargaIndex/descargarPlantillaCargaIndex`, method: 'GET', body: null, token: token})
}
